export const env = process.env.NODE_ENV
export const domain = env === 'production' ? 'api.mercedeshk.com' : window.location.hostname+':3066'
export const ssl = env === 'production'
export const autoLogoutTime = 4500